import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideSectionTextBlockData from '../../../Models/Content/GenericGuideSectionTextBlockData';
import GenericGuideSectionText from './GenericGuideSectionTextBlock';

export default class GenericGuideSectionTextBlock extends EpiComponent<GenericGuideSectionTextBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-section-text-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideSectionText iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

